"use strict";

var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    className: "plus-symbol"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 .015h2V10H4V.014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.015 4H10v2H.015V4z"
  }));
};